export default __webpack_public_path__ + "static/media/motor.d18f8c21.png";